export const isZipGenerationSession = (session) => session?.generation_type === 'download_zip';

export const generationSessionType = (session) =>
  isZipGenerationSession(session) ? 'ZIP generation' : 'Playground';
